import React, { SetStateAction, useContext, useRef, useState } from "react";
import {
  BackIcon,
  DarkModeIcon,
  EmailIcon,
  LightModeIcon,
  PasswordIcon,
  UsernameIcon,
} from "../../components/iconSet/IconSet";
import { ThemeTypes } from "../../context/ContextTypes";

import logoIcon from "../../images/icons/logo.png";
import { useNavigate } from "react-router-dom";
import {
  APICall,
  DATA_VALIDATION_ERROR,
  USER_CREDENTIALS_ERROR,
} from "../../services/APIService";
import {
  API_LOGIN_URL,
  APILoginType,
} from "../../services/APIAuthorizationService";
import { useTheme } from "../../context/ThemeContext";
import { generatePKCE } from "../../utils/keycloakPKCEUtils";
import AlertDialog from "../../components/popupComp/AlertDialog";
import axios from "axios";

const ForgotPassword = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const { theme, setTheme } = useTheme();

  const usernameRef = useRef<HTMLInputElement | null>(null);

  const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK
  
    const showAlertDialog = (
    title: string,
    description: string,
    yesCallback?: () => void,
    okCallback?: () => void
    ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
    setAlertOkCallback(() => okCallback);   // Will trigger only on OK
    setAlertDialogState(true);
    };

  const [status, setStatus] = useState<{
    type: "success" | "error";
    message: string;
  } | null>(null);

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);

    const inputValue = usernameRef.current?.value.trim();
    if (!inputValue) {
      showAlertDialog("Validation Error", "❗ Please enter your email.");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/jwt-auth/api/v1/forgot-password`,
        { email: inputValue },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      setStatus({ type: "success", message: response.data.message });
      showAlertDialog("✅ Success", "Password reset email sent successfully.",undefined,() => window.location.reload());
    } catch (error: any) {
      const message =
        error.response?.data?.error ||
        "Something went wrong. Please try again.";
      setStatus({ type: "error", message });
      showAlertDialog("❌ Error", message);
    }
  };

  const handleForgetPasswordClick = (e: React.FormEvent) => {
    handleForgotPassword(e);
  };

  const handleThemeChangeClick = (type: ThemeTypes) => {
    setTheme((prevState) => type);
  };

  return (
    <div className={`login-page-wrapper ${theme}`}>
      <div className={`login-container`}>
        <div className={`form-area`}>
          <span className={`title`}>Forgot Password ?</span>
          <div className={`input-wrapper`}>
            <i>
              <EmailIcon color="var(--color-main-white)" width="1.2rem" />
            </i>
            <input
              type="text"
              
              placeholder="Email"
              ref={usernameRef}
            />
          </div>
          <div className={`button-wrapper`}>
            <button
              className={`button-full`}
              onClick={handleForgetPasswordClick}
            >
              Send
            </button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.3rem",
              marginTop: "1.0rem",
              cursor: "pointer",
              fontSize: "0.5rem",
              color: "var(--color-main-black)",
              fontWeight: "bold",
              transition: "opacity 0.3s ease",
            }}
            onClick={() => navigate("/login")}
            onMouseOver={(e) => {
              e.currentTarget.style.opacity = "0.7";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
          >
            <BackIcon width="0.8rem" color="var(--color-main-black)" />
            <span style={{ fontSize: "0.8rem", fontWeight: "bold" }}>Back to Login</span>
          </div>
        </div>
        <div className={`logo-area`}>
          <img className={`logo-image`} src={logoIcon} alt="" />
          <span className="title">BCONX</span>
          <span className="water-mark">Powered by Tecxal Systems</span>
        </div>

        {theme === "dark" ? (
          <div
            className={`theme-button-wrapper`}
            onClick={(e) => handleThemeChangeClick("light")}
          >
            <LightModeIcon color="white" width="2rem" />
          </div>
        ) : theme === "light" ? (
          <div
            className={`theme-button-wrapper`}
            onClick={(e) => handleThemeChangeClick("dark")}
          >
            <DarkModeIcon color="white" width="1rem" />
          </div>
        ) : null}
      </div>
      {alertDialogState && (
            	<AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertYesCallback}
                okFunction={alertOkCallback}
            />
            )}
    </div>
  );
};

export default ForgotPassword;
